import { FieldInput } from '@advanza/advanza_generic'
import {
    appendMapsScript,
    mapsPromise,
} from '@advanza/advanza_generic/src/services/googleMapsLoader'
import { InputField } from '@advanza/input'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

class GeoAutoComplete extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mapsLoaded: false,
        }
        this.textInput = null

        this.autoCompleteInit = this.autoCompleteInit.bind(this)
        this.placeChanged = this.placeChanged.bind(this)
    }
    componentWillMount() {
        appendMapsScript()
    }

    componentDidMount() {
        mapsPromise()
            .then(this.autoCompleteInit)
            .catch((error) => {
                console.error('Failed to load Google Maps API:', error)
                // Set a flag to indicate maps failed to load
                this.setState({ mapsLoaded: false })
            })
    }

    autoCompleteInit(maps) {
        const options = this.props.options || {}
        if (!maps || !maps.maps || !maps.maps.places) {
            console.warn('Google Maps API not properly loaded or Places library not available', {
                maps: !!maps,
                mapsMaps: !!(maps && maps.maps),
                mapsPlaces: !!(maps && maps.maps && maps.maps.places),
            })
            this.setState({ mapsLoaded: false })
            return
        }

        try {
            this.autocomplete = new maps.maps.places.Autocomplete(this.textInput, {
                ...options,
                placeholder: null,
            })
            this.autocomplete.addListener('place_changed', this.placeChanged)
            this.setState({ mapsLoaded: true })
        } catch (error) {
            console.error('Failed to initialize Google Maps Autocomplete:', error)
            this.setState({ mapsLoaded: false })
        }
    }

    placeChanged() {
        const place = this.autocomplete.getPlace()
        const { onChange, name, onPlaceChange, defaultResultKey } = this.props
        onChange &&
            onChange({
                target: {
                    name,
                    value: place[defaultResultKey] || place.formatted_address,
                },
            })
        onPlaceChange && onPlaceChange(place)
    }

    render() {
        const { icon, onPlaceChange, defaultResultKey, ...rest } = this.props
        const { mapsLoaded } = this.state

        return (
            <div>
                <InputField
                    ref={(input) => (this.textInput = input && input.ref)}
                    icon={icon === false ? false : 'place'}
                    value={rest.state.value}
                    inputPlaceholder=""
                    errors={rest.state.error}
                    placeholder={rest.msg}
                    {...rest}
                />
                {!mapsLoaded && (
                    <div
                        style={{
                            fontSize: '12px',
                            color: '#666',
                            marginTop: '4px',
                            fontStyle: 'italic',
                        }}>
                        Location autocomplete unavailable - please enter address manually
                    </div>
                )}
            </div>
        )
    }
}

GeoAutoComplete.propTypes = {
    defaultResultKey: PropTypes.string,
    icon: PropTypes.any,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onPlaceChange: PropTypes.func,
    options: PropTypes.object,
    state: PropTypes.object,
}

export default GeoAutoComplete
